/** @file This file contains type definitions hand function to handle colors when generating a document. */
/**
 * Extracts the string hex code from a color object.
 *
 * @param color A color object.
 * @returns A string representing the color in hex code.
 */
export function colorToString(color) {
    /**
     * Converts a number into a hex string.
     *
     * @param x The number to convert.
     * @returns The hex string corresponding to the number.
     */
    const toHex = (x) => x.toString(16).padStart(2, '0');
    return `${toHex(color.red)}${toHex(color.green)}${toHex(color.blue)}`;
}
